export default {
      id: "icon-scroll-top-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-scroll-top",
      toString: function () {
        return this.url;
      }
    }